import { eventKey as CONDUCTOR_PETE_EVENT_KEY } from "@faire/web-api--source/events/conductor/actionUnknown/conductorDrivenEvent";
import { IAction } from "@faire/web-api--source/indigofair/data/IAction";
import { trackClientEvent } from "@faire/web-api--source/trackClientEvent";

export const handleLoggingAction = (sduiActions: IAction[]) => {
  const logEventAction = sduiActions.find(
    (action) => action.log_event
  )?.log_event;

  if (!logEventAction || !logEventAction.event_name) {
    return;
  }

  // Special key for Conductor events as we want to track the pathname in the 2nd parameter
  // What comes from BE is hardcoded as it doesn't know the pathname.
  if (logEventAction.event_name === CONDUCTOR_PETE_EVENT_KEY) {
    const [firstParam, _, ...rest] = logEventAction.parameters;
    const parametersWithPathName = [
      firstParam,
      window.location.pathname,
      ...rest,
    ];

    trackClientEvent({
      eventKey: logEventAction.event_name,
      parameters: parametersWithPathName,
    });
  } else {
    trackClientEvent({
      eventKey: logEventAction.event_name,
      parameters: logEventAction.parameters,
    });
  }
};
